<template>
  <div class="main-container" :style="{background: backgroundColor, paddingBottom: paddingBottom}">
    <v-card class="newsletter-card" elevation="0">
      <v-card-text class="newsletter-content">
        <v-row align="center" class="section">
          <v-col cols="12" md="4" class="title-section">
            <h1 class="newsletter-title">Subscribe to our newsletter!</h1>
            <p class="newsletter-subtitle">Get Exclusive Insights, Updates & Stories</p>
          </v-col>
          <v-col cols="12" md="4">
            <!-- Conditionally render form or thank you message -->
            <div v-if="!subscribed">
              <v-row dense>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="firstName"
                    label="First Name *"
                    aria-label="Your First Name"
                    class="input-field m500 mb-3"
                    bg-color="#f7f8fc"
                    clearable
                    aria-required="true"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="lastName"
                    label="Last Name *"
                    aria-label="Your Last Name"
                    class="input-field m500 mb-3"
                    bg-color="#f7f8fc"
                    clearable
                    aria-required="true"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="email"
                    label="Email *"
                    aria-label="Your Email"
                    class="input-field m500 mb-3"
                    bg-color="#f7f8fc"
                    clearable
                    :error-messages="errors.email"
                    type="email"
                    autocomplete="email"
                    aria-required="true"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="text-left">
                  <v-btn
                    class="subscribe-button"
                    :loading="loading"
                    @click="subscribe"
                  >
                    Subscribe
                  </v-btn>
                  <div v-if="validationMessages.length" class="validation-messages">
                    <p v-for="(message, index) in validationMessages" :key="index" class="error-text">
                      {{ message }}
                    </p>
                  </div>
                </v-col>
              </v-row>
            </div>
            <div v-else class="thank-you-message">
              <p class="thank-you-text">
                Thank you <span style="color: #FF6860B2;">{{ subscribedFirstName }}</span> for subscribing. You’ll now receive exclusive insights, updates, and stories—from tech trends to product strategies—straight to your inbox.
              </p>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import newsletterService from '@/services/API/newsletterService';

export default {
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      loading: false,
      subscribed: false,
      subscribedFirstName: '',
      errors: {
        firstName: '',
        lastName: '',
        email: '',
      },
      validationMessages: [],
    };
  },
  props: {
    backgroundColor: {
      type: String,
      default: '#f9f9f9', 
    },
    paddingBottom: {
      type: String,
      default: '4rem',
    },
  },
  methods: {
    validateForm() {
      this.errors = {
        firstName: '',
        lastName: '',
        email: '',
      };
      this.validationMessages = [];

      let isValid = true;

      if (!this.firstName.trim() || !this.lastName.trim() || !this.email.trim()) {
        this.validationMessages.push('please fill all required fields');
        isValid = false;
      }
      if (!this.lastName.trim()) {
        this.validationMessages.push('Last Name is required');
        isValid = false;
      }
      if (!this.email.trim()) {
        this.errors.email = 'Email is required';
        this.validationMessages.push('Email is required');
        isValid = false;
      } else if (!/.+@.+\..+/.test(this.email)) {
        this.errors.email = 'Email must be valid';
        this.validationMessages.push('Email must be valid');
        isValid = false;
      }

      return isValid;
    },
    async subscribe() {
      // Clear previous errors
      this.errors = {
        firstName: '',
        lastName: '',
        email: '',
      };
      this.validationMessages = [];

      // Validate form
      if (!this.validateForm()) {
        return;
      }

      this.loading = true;
      try {
        const newsletterData = {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
        };

        await newsletterService.createNewsletter(newsletterData);

        this.subscribedFirstName = this.firstName;
        this.subscribed = true;

        // Clear form fields
        this.firstName = '';
        this.lastName = '';
        this.email = '';
      } catch (error) {
        console.error('Subscription failed:', error);
        this.errors.email = 'Failed to subscribe. Please try again later.';
        this.validationMessages.push('Failed to subscribe. Please try again later.');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.main-container {
  padding-bottom: 4rem;
}

.newsletter-card {
  background: url('@/assets/img/newsletterbackground.svg') no-repeat center center;
  background-size: cover;
  padding: 2rem;
  max-width: 1280px;
  margin: 0 auto;
}

.newsletter-content {
  padding: 0;
}
.section {
  display: flex;
  justify-content: space-around;
  text-align: left;
}
.title-section {
  margin: 2rem 0;
}
.newsletter-title {
  color: white;
  font-size: clamp(28px, 5vw, 44px);
  font-weight: bold;
  margin-bottom: 10px;
}

.newsletter-subtitle {
  color: white;
  font-size: 1.1em;
  margin-bottom: 20px;
}

.input-field {
  color: black !important;
  height: 56px;
  border-radius: 5px;
  margin-bottom: 1rem;
}

/* Remove dark underline from v-text-field */
.v-text-field .v-input__control .v-field__field {
  border-bottom: none !important;
}

.v-text-field .v-input__control .v-field__underline {
  display: none !important;
}

.v-text-field .v-field {
  border: none !important;
  background-color: #f7f8fc !important;
}

.subscribe-button {
  background-color: #007ab2;
  text-transform: capitalize;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  margin-top: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out, transform 0.2s ease-in-out;
  height: 50px;
}

.subscribe-button:hover {
  background-color: #00aeff;
  transform: scale(1.05);
}

.subscribe-button:disabled {
  background-color: #b0bec5 !important;
  color: #78909c !important;
}

.thank-you-message {
  text-align: center;
}

.thank-you-text {
  color: #333;
  font-size: 1.1em;
  background-color: #c3ffe9;
  padding: 1rem;
  border-radius: 8px;
  margin: 0;
}

.validation-messages {
  margin-top: 1rem;
}

.error-text {
  color: #d32f2f;
  font-size: 0.875rem;
  margin: 0.25rem 0;
}

@media (max-width: 600px) {
  .newsletter-title {
    font-size: 1.5em;
  }

  .newsletter-subtitle {
    font-size: 1em;
  }

  .subscribe-button {
    width: 100%;
  }

  .thank-you-text {
    font-size: 1em;
  }
}
</style>